import classNames from "classnames"
import React, { isValidElement } from "react"

type Props = {
    marginPx: string
    className?: string
    justify?: "start" | "end"
}

/**
 * https://frontarm.com/james-k-nelson/passing-data-props-children/
 * https://developer.mozilla.org/en-US/docs/Web/CSS/CSS_Flexible_Box_Layout/Mastering_Wrapping_of_Flex_Items#Creating_gutters_between_items
 */
export const WrappingDiv: React.FC<Props> = (props) => {

    // What's going on here is that we clone all the children we receive, and while doing
    // that we set their margin prop for them. This allows us to only set the margin on
    // the parent when using this component.
    const childrenWithMargins = React.Children
        .toArray(props.children)
        .map(child => {
            if (isValidElement(child)) {
                // TODO: TS will spaz out if you pass this anonymously
                // into the cloneElement function. No idea why.
                const _props = {
                    style: {
                        // Important that we keep whatever style props the child had...
                        ...child.props.style,
                        margin: props.marginPx
                    }
                }

                return React.cloneElement(child, _props)
            }

            throw new Error(`Unexpected element, not sure what happened`)
        })

    return (
        <div className={classNames(
            props.className
        )}>
            {/*
                So what's going on is that this inner div has negative
                margin leaking out of it, but that won't affect us, because
                we have a wrapping div giving us the correct bounding box.

                This trick allows our children to push each other away via
                margins, without creating gaps near the edges. CSS amirite.
            */}

            <div
                className={classNames(
                    "d-flex flex-wrap align-items-start",
                    { 'justify-content-start': props.justify == null || props.justify === "start" },
                    { 'justify-content-end': props.justify === "end" },
                )}
                style={{ margin: `-${props.marginPx}` }}
            >
                {childrenWithMargins}
            </div>
        </div>
    )
}
